import { render } from "./PreviewLink.vue?vue&type=template&id=17e8713b&scoped=true"
import script from "./PreviewLink.vue?vue&type=script&lang=js"
export * from "./PreviewLink.vue?vue&type=script&lang=js"

import "./PreviewLink.vue?vue&type=style&index=0&id=17e8713b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17e8713b"

export default script